module.exports = __webpack_public_path__ + "static/img/101_TO8_1782.a03ca7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/101_TO8_1782.jpg
// module id = Usf6
// module chunks = 0